// extracted by mini-css-extract-plugin
export default {"header":"Header_header__+fVOB","headerBack":"Header_headerBack__c8Jw7","headerProfile":"Header_headerProfile__3n29s","headerTitle":"Header_headerTitle__3LURf"};